module.exports = __webpack_public_path__ + "static/media/wordpress.df9a6c9d.svg";